import React from 'react';
import PropTypes from 'prop-types';
import DialogWithSuccessLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithSuccessLayout';
import Button from '@Components/Button';

export const remoteAccessActivationSuccessDialogMessage = 'Your remote access to Reaxys has been successfully activated.';

function ActivationSuccessDialog(props) {
  const { selfClose, message } = props;

  return (
    <DialogWithSuccessLayout
      {...props}
      size="md"
      header="Remote access activated successfully"
      headerClassName="rx-border-none"
      footer={
        <div className="els-btn-group-right">
          <Button
            buttonConfig={{
              type: 'primary',
              size: 'sm',
              label: 'Got it',
              e2eName: 'remote-access-activation-success-ok',
            }}
            onClick={selfClose}
          />
        </div>
      }
      footerClassName="rx-border-none">
      {message || remoteAccessActivationSuccessDialogMessage}
    </DialogWithSuccessLayout>
  );
}

ActivationSuccessDialog.propTypes = {
  selfClose: PropTypes.func.isRequired,
  message: PropTypes.string,
};

export default ActivationSuccessDialog;
